<template>
  <div>
    <!-- 关联标签 -->
    <el-form-item label="选择进货渠道">
      <el-input v-model="form.supply.name" style="width: 200px;" class="max-w460"></el-input>
      <el-button type="primary"  style="margin-left: 10px;" @click="changeProduct()">选择进货渠道</el-button>
      <el-button style="margin-left: 10px;"   @click="deleteClick()">清除进货渠道</el-button>
    </el-form-item>
    <!--标签选择-->
    <Supply :isproduct="isproduct" @closeDialog="closeDialogFunc"></Supply>

  </div>
</template>

<script>
import Supply from '@/components/supply/Supply_rk';
import {mergeTable} from '@/utils/table.js';

export default {
  components: {
    /*选择商品组件*/
    Supply,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
    };
  },
  props: {
    form: Object
  },
  methods: {
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        var supply = {
          name:e.params[0].name,
          supply_id:e.params[0].supply_id,
        }
        self.form.supply = supply
        self.form.supply_id = supply.supply_id

        this.$emit('closeDialogs', {
       
        });
      }
    },
    /*打开添加*/
    changeProduct() {
      
      this.isproduct = true;
    },
    /*删除标签*/
    deleteClick() {
      let self = this;
       self.form.supply = ''
        self.form.supply_id = 0
    },
  }
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/supply/supply_common_rk.vue